import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaUserCircle } from 'src/components/AdminPageLayout/icons';
import { useTranslation } from 'src/hooks/useTranslation';
import { ROUTES } from 'src/services/navigation/constants';
import { goToLogout } from 'src/services/navigation';

import * as styles from './ProfileDropdown.module.scss';

const ProfileDropdown = ({ user, children }) => {
  const { t } = useTranslation();
  const displayName =
    user?.given_name
      ? `${user?.given_name || ''} ${user?.family_name || ''}`.trim()
      : user?.FirstName
        ? `${user?.FirstName || ''} ${user?.LastName || ''}`.trim()
        : user?.Value || user?.email || '';
  const email = user?.email || user?.Email || '';

  return (
    <Dropdown align="end" className={styles.dropdown}>
      <Dropdown.Toggle
        as="div"
        className={styles.toggle}
        data-testid="profile-dropdown-toggle"
      >
        {children}
      </Dropdown.Toggle>

      <Dropdown.Menu className={styles.menu}>
        <div className={styles.header}>
          <FaUserCircle className={styles.avatarLarge} />
          <div className={styles.info}>
            <div className={styles.name}>{displayName || t('User')}</div>
            {email && <div className={styles.email}>{email}</div>}
          </div>
        </div>
        <Dropdown.Divider />
        <Dropdown.Item as={Link} to={ROUTES.ACCOUNT} className={styles.item}>
          {t('Overview')}
        </Dropdown.Item>
        <Dropdown.Item as={Link} to={ROUTES.PROFILE} className={styles.item}>
          {t('Profile')}
        </Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item
          onClick={goToLogout}
          className={styles.logoutItem}
          data-testid="profile-logout"
        >
          {t('Log out')}
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProfileDropdown;
